import { useEffect } from "react";
import { toast } from "sonner";

const KEY = "fp_app_version";

// Wykrywa zmianę wersji backendu (po automatycznej/ręcznej aktualizacji) i pokazuje powiadomienie.
export default function UpdateNotifier() {
  useEffect(() => {
    let stop = false;
    const base = process.env.REACT_APP_BACKEND_URL;
    const check = async () => {
      try {
        const res = await fetch(`${base}/api/version`, { cache: "no-store" });
        if (!res.ok) return;
        const { version } = await res.json();
        if (!version) return;
        const prev = localStorage.getItem(KEY);
        if (prev && prev !== version) {
          toast.success(`Zaktualizowano aplikację do wersji ${version}. Odświeżam…`, { duration: 6000 });
          localStorage.setItem(KEY, version);
          setTimeout(() => window.location.reload(), 3500);
          return;
        }
        localStorage.setItem(KEY, version);
      } catch { /* offline — ignoruj */ }
    };
    check();
    const id = setInterval(() => { if (!stop) check(); }, 90000);
    return () => { stop = true; clearInterval(id); };
  }, []);
  return null;
}
